var _desc, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.3")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.24115545204629 0 0 2.8190737733968954 246.09242602321933 250)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.06549999999999656 -35.81900000000001)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "14.861500000000003,-0.16299999999999848 0.22149999999999537,-8.65 -14.861500000000003,0.09299999999999997 -0.34050000000000225,8.65 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -18.200499999999998 -24.9715)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-31.299500000000002, -24.5285)",
    d: "M 28.38 26.134 c 1.443 0 6.616 0 9.821 0 c 0 0 -3.07 -3.211 -7.615 -3.211 c -3.201 0 -5.088 0.884 -6.188 1.811 C 24.401 24.736 24.894 26.134 28.38 26.134 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -28.499499999999998 0.8979999999999961)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-21.000500000000002, -50.397999999999996)",
    d: "M 31.354 32.692 c -1.048 0.037 -2.011 0.058 -2.842 0.058 c -6.522 0 -5.584 -5.909 -5.584 -5.909 l 1.309 -6.998 l -13.59 7.728 v 15.08 l 1.776 1.024 v 29.607 l 13.196 7.671 V 36.016 L 31.354 32.692 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 18.849500000000006 -25.025181374368415)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-68.3495, -24.474818625631585)",
    d: "M 74.935 24.745 c -1.098 -0.932 -3.027 -2.328 -6.2 -1.822 c -3.751 0.599 -6.971 3.211 -6.971 3.211 c 3.214 0 7.85 0 9.204 0 C 73.71 26.134 74.781 24.852 74.935 24.745 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 28.34750000000001 0.9549999999999983)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-77.84750000000001, -50.455)",
    d: "M 88.97 27.752 l -13.915 -8.074 l 1.367 7.162 c 0 0 0.937 5.909 -5.584 5.909 c -1.157 0 -2.571 -0.041 -4.113 -0.108 l 6.747 3.99 v 44.601 l 13.679 -7.951 V 43.698 l 1.819 -1.048 V 27.752 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.4089999999999989 15.892499999999998)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "4.987000000000002,-29.6075 5.7479999999999976,-19.8975 -0.2669999999999959,-22.7425 -6.18,-19.8975 -5.530000000000001,-29.179499999999997 -14.966000000000001,-23.7085 -14.966000000000001,20.795500000000004 -0.12199999999999989,29.6075 14.966000000000001,20.837500000000006 14.966000000000001,-23.8395 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxSmall);
export default __webpack_public_path__ + "static/media/boxSmall.ee7fce18fb7697202fc5184f00a0a7b8.svg";
export { ForwardRef as ReactComponent };